import { render, staticRenderFns } from "./CartItems.vue?vue&type=template&id=3e5496bc"
import script from "./CartItems.vue?vue&type=script&lang=js"
export * from "./CartItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5496bc')) {
      api.createRecord('3e5496bc', component.options)
    } else {
      api.reload('3e5496bc', component.options)
    }
    module.hot.accept("./CartItems.vue?vue&type=template&id=3e5496bc", function () {
      api.rerender('3e5496bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/cart/CartItems.vue"
export default component.exports